//LOCAL SET UP
// let server_url="http://127.0.0.1:8000";
// let backend_url=server_url+'';
// let assets_url='http://localhost:8080/';
// let server_client_secret="lk2jmEoskvQMAI5jbMY8ew3vtsRdqCLS2VZ65UCG";

//LOCAL SET UP BUILD
// let server_url="http://localhost";
// let backend_url=server_url+'/franco_time_log/back_dev/public';
// let assets_url='http://localhost/franco_time_log/build/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";

//LIVE SET UP
// let server_url="http://localhost";
// let backend_url=server_url+'/franco_time_log/back_dev/public';
// let assets_url='http://localhost/franco_time_log/build/';
// let server_client_secret="jH4nVdYZfkkXg7imAK6jdvt1y5TohLP0RzDoD3NI";

//LIVE SET UP SERVER
// let server_url="http://209.97.170.23:8861";
// let backend_url=server_url;
// let assets_url='http://209.97.170.23:8863/';
// let server_client_secret="SOfTj8QUiVj26zA7vLeWbiDgiKTJGLjv9fUtY7JD";
// let router_base='/';

//LIVE SET UP SERVER HTTPS
let server_url="https://rcsdc.live";
let backend_url=server_url;
let assets_url='https://rcsdc.live/';
let server_client_secret="SOfTj8QUiVj26zA7vLeWbiDgiKTJGLjv9fUtY7JD";
let router_base='/';



export const assets_path = Object.freeze({
    DEFAULT_URL: assets_url,
    EMPLOYEE_LOGS: backend_url + "/storage/uploads/site_timelogs/"
});
export const client_details = Object.freeze({
    CLIENT_ID: "3",
    CLIENT_SECRET: server_client_secret
});
export const server_details = Object.freeze({
    SERVER_URL: backend_url+"/api/",
    BASE_SERVER_URL: backend_url,
});